/**
 * Standard header chrome for an admin view — single active tab in
 * the same `TabStrip` instance the canvas uses, optional `actions`
 * slot on the right (column picker, refresh button, etc.). Each view
 * renders its own header so view-specific actions stay co-located
 * with the view that owns them, instead of being lifted up through
 * AdminPage state.
 */
import TabStrip from "./TabStrip.jsx";
import { EYEBROW_CLASS } from "../lib/ui.js";

// Every admin surface renders this, including pages that build their own tab
// strip — a hand-rolled copy drifts in size and tracking.
export function ScopeLabel({ children }) {
    return (
        <span className={`${EYEBROW_CLASS} flex min-h-[38px] items-center whitespace-nowrap text-[color:var(--green)] max-[880px]:hidden`}>
            Scope: {children}
        </span>
    );
}

export default function AdminViewHeader({ title, scope = null, tabs = null, actions = null }) {
    const headerActions = scope || actions ? (
        <div className="flex min-h-[38px] items-center gap-[8px]">
            {scope ? <ScopeLabel>{scope}</ScopeLabel> : null}
            {actions}
        </div>
    ) : null;

    const resolvedTabs = tabs ?? [{
        id: "view",
        label: title,
        active: true,
        dot: "bg-[color:var(--green)]",
    }];

    return (
        <header className="shrink-0 overflow-hidden">
            <TabStrip
                tabs={resolvedTabs}
                actions={headerActions}
                className="pt-[11px] max-[900px]:pt-[8px]"
            />
        </header>
    );
}
